module.exports = __webpack_public_path__ + "static/media/38.08694321.png";